<template>
  <div class="text-center text-sm-start text-h5 text-sm-h1">
    <span class="Dm-display"><slot /></span>
  </div>
</template>
<script>
export default {};
</script>
